var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-sortable",
        {
          attrs: {
            tag: "w-list",
            items: _vm.types,
            "keep-in-y": "",
            "target-class": "handle",
          },
          on: {
            drop: function ($event) {
              return _vm.setOrder()
            },
          },
        },
        [
          _vm._l(_vm.types, function (t) {
            return _c(
              "w-list-item",
              { key: t.ID, attrs: { "show-handle": "" } },
              [
                _c("w-list-item-text", [
                  _vm._v(_vm._s(t.getDisplayedName(_vm.locale)) + " "),
                  _vm.getStockConfig(t.ID)
                    ? _c("span", { staticClass: "field" }, [
                        _vm._v(_vm._s(_vm.$ct("compute-stock"))),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit-settings"),
                            expression: "$ct('edit-settings')",
                          },
                        ],
                        attrs: { to: "/settings/sales/types/" + t.ID },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.delete"),
                            expression: "$ct('common.delete')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { disabled: !t.canBeDeleted() },
                        on: {
                          click: function ($event) {
                            return _vm.deleteType(t)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm.types.length == 0
            ? _c(
                "w-list-item",
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("common.empty"))),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.canCreate
            ? _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.openCreateModal()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.createButtonText)),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.createNew,
            callback: function ($$v) {
              _vm.createNew = $$v
            },
            expression: "createNew",
          },
        },
        [
          _vm.createNew
            ? _c("app-sale-type-new", {
                attrs: { "contact-group-id": _vm.contactGroupId },
                on: {
                  close: function ($event) {
                    _vm.createNew = false
                  },
                  saved: function ($event) {
                    return _vm.onNewCreated($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }